import React from "react";
import "../NagthaneComponent/NagthaneCss/SchoolsSection.css";
import govtImg from "../Images/im4.jpg";
import privateImg from "../Images/im3.jpg";
import govtSir from "../Images/im2.jpg";
import privateSir from "../Images/im1.png";

export default function SchoolsSection() {
  return (
    <section className="schools-wrapper">
      <h1 className="main-title">
        ज्ञानाचा सेतू – शासकीय ते खाजगी शिक्षणापर्यंत
      </h1>
      <p className="sub-title">ज्ञान, संस्कार आणि प्रगती यांचे केंद्रस्थळ</p>
      <p className="sub-title2">
        गावाच्या शैक्षणिक प्रगतीचा आधारस्तंभ असलेल्या आमच्या शाळा
      </p>

      <div className="schools-grid">
        {/* ✅ शासकीय शाळा */}
        <div className="school-card">
          <h2 className="school-heading">शासकीय शाळा</h2>

          <img src={govtImg} alt="Government School" className="school-photo" />

          <div className="info-grid">
            <p>शालेय मुलं : ९०</p>
            <p>शालेय मुली : ११०</p>
            <p>एकूण शिक्षक : २०</p>
            <p>संपर्क : ९८७६५४३२१५</p>
          </div>

          <div className="principal-box">
            <img src={govtSir} className="principal-img" alt="Principal" />
            <div>
              <h4>प्रो. श्री. निलेश अर्जुन पवार</h4>
              <p>शासकीय शाळा मराठी मुख्याध्यापक</p>
            </div>
          </div>
        </div>

        {/* ✅ खाजगी शाळा */}
        <div className="school-card">
          <h2 className="school-heading">खाजगी शाळा</h2>

          <img src={privateImg} alt="Private School" className="school-photo" />

          <div className="info-grid">
            <p>शालेय मुलं : २००</p>
            <p>शालेय मुली : १८५</p>
            <p>एकूण शिक्षक : ३०</p>
            <p>संपर्क : ९८७६५४३२१५</p>
          </div>

          <div className="principal-box">
            <img src={privateSir} className="principal-img" alt="Principal" />
            <div>
              <h4>प्रो. श्री. निलेश अर्जुन पवार</h4>
              <p>शासकीय शाळा मराठी मुख्याध्यापक</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
